module.exports = __webpack_public_path__ + "img/c vd Houtstr na.629beb30.jpg";